<template>
  <div class="flex space-x-3 status-header">
    <span class="ag-header-cell-text">
      {{tooltip[this.params.column.colId]['col_title']}}
    </span>
    <span class="float-right">
      <vx-tooltip class="flex" position="top" ref="tooltip">
        <template slot="html">
          <div class="flex tooltip-slot">
            <ul class="list-disc flex-wrap">
              <li class="w-full">
                <span class="li-title">{{tooltip[this.params.column.colId]['active_title']}}: </span>
                <span class="flex-nowrap li-desc">{{tooltip[this.params.column.colId]['active_desc']}}</span>
              </li>

              <li class="w-full mt-2">
                <span class="li-title">{{tooltip[this.params.column.colId]['no_activity_yet_title']}}: </span>
                <span class="flex-nowrap li-desc"> {{tooltip[this.params.column.colId]['no_activity_yet_desc']}}</span>
              </li>

              <li class="w-full mt-2">
                <span class="li-title">{{tooltip[this.params.column.colId]['no_recent_activity_title']}}: </span>
                <span class="flex-nowrap li-desc">{{tooltip[this.params.column.colId]['no_recent_activity_desc']}}</span>
              </li>
            </ul>
          </div>
        </template>
        <vs-icon class="flex justify-center items-center tooltip-right-icon" icon-pack="speakol" icon="speakol-info" :color="'#323232'"></vs-icon>
      </vx-tooltip>
    </span>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tooltip: {
        main_pixel_code_status: {
          'col_title': this.$t('tracking.conversions_tab.table.main_pixel_code'),
          'active_title': this.$t('tracking.conversions_tab.table.tooltips.main_pixel.active_title'),
          'active_desc': this.$t('tracking.conversions_tab.table.tooltips.main_pixel.active_desc'),

          'no_activity_yet_title': this.$t('tracking.conversions_tab.table.tooltips.main_pixel.no_activity_yet_title'),
          'no_activity_yet_desc': this.$t('tracking.conversions_tab.table.tooltips.main_pixel.no_activity_yet_desc'),

          'no_recent_activity_title': this.$t('tracking.conversions_tab.table.tooltips.main_pixel.no_recent_activity_title'),
          'no_recent_activity_desc': this.$t('tracking.conversions_tab.table.tooltips.main_pixel.no_recent_activity_desc')
        },
        status: {
          'col_title': this.$t('tracking.conversions_tab.table.status'),
          'active_title': this.$t('tracking.conversions_tab.table.tooltips.status.active_title'),
          'active_desc': this.$t('tracking.conversions_tab.table.tooltips.status.active_desc'),

          'no_activity_yet_title': this.$t('tracking.conversions_tab.table.tooltips.status.no_activity_yet_title'),
          'no_activity_yet_desc': this.$t('tracking.conversions_tab.table.tooltips.status.no_activity_yet_desc'),

          'no_recent_activity_title': this.$t('tracking.conversions_tab.table.tooltips.status.no_recent_activity_title'),
          'no_recent_activity_desc': this.$t('tracking.conversions_tab.table.tooltips.status.no_recent_activity_desc')
        }
      }
    }
  }
}
</script>
<style lang="scss">
$fontColor: #f9f9f9;

.status-header {
  align-items: center;
}

.vs-tooltip {
  max-width: 390px;
}

.tooltip-slot {
  padding-left: 10px;
  margin: 19px;
}

.li-title {
  font-weight: bold;
  font-size: 12px;
  line-height: 24px;
  letter-spacing: 0.233333px;
  color: $fontColor;
}

.li-desc {
  font-size: 12px;
  line-height: 24px;
  letter-spacing: 0.233333px;
  color: $fontColor;
}

.tooltip-right-icon {
  height: 17px;
  font-weight: 500;
}

.tooltip-right-icon.vs-icon {
  font-size: 16px !important;
}

.vs-tooltip-bottom {
  margin-top: 6px;
}
</style>

